import { render, staticRenderFns } from "./arrangement.vue?vue&type=template&id=1bfe709d&"
import script from "./arrangement.vue?vue&type=script&lang=js&"
export * from "./arrangement.vue?vue&type=script&lang=js&"
import style0 from "./arrangement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports